@let b = brand();
<section class="header">
    <div class="header-content py-10 px-10 f-cross-center">
        <img class="logo mr-10" [src]="(b?.logo_url | bucket) ?? 'old/cloudigo_loader.svg'" [alt]="b?.name" [fallback] alt="{{(b?.name || 'Brand')}} logo"/>
        <div>
            <h2 class="m-0 font-extrabold" paint="blue">
                {{b?.name}} Discount Offers and Store Locations
            </h2>
            <p class="mb-0 mt-4" paint="gray">{{year}} | {{(b?.offers||[]).length}} {{b?.name}} Voucher Codes Available</p>
        </div>
    </div>
    <nav mat-tab-nav-bar [tabPanel]="panel">
        @for(tabInfo of tabsInfo; track tabInfo.key){
            <a mat-tab-link [routerLink]="['./']" [queryParams]="{ tab: tabInfo.key }" [active]="tab() == tabInfo.key">{{tabInfo.value}}</a>
        }
    </nav>
</section>
<section class="body">
    <div>
        <mat-tab-nav-panel #panel>
            <div class="py-20 px-5">
                @switch(tab()){
                    @case('offers'){
                        <div class="offer-groups f-wrap f-main-around f-cross-start rgap-10">
                            @for(group of plans(); track group.plan){
                                <div class="group">
                                    <div class="group-header f-cross-center f-main-between px-8" [plan]="group.plan" design="fancy">
                                        <h4 class="m-0 font-extrabold">{{group.plan | uppercase }}</h4>
                                        <!-- TODO: LEARN MORE? -->
                                    </div>
                                    <div class="offers p-5">
                                        @for(offer of group.offers; track offer._id){
                                            <offer-card [offer]="offer"></offer-card>
                                            @if(!$last){
                                                <mat-divider style="margin: 0 50px;"/>
                                            }
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    @case('about'){
                        <div class="about py-20">
                            <div class="header f-main-between f-cross-center cgap-5">
                                <h3 class="m-0 font-extrabold" paint="blue">
                                    About {{b?.name}}
                                </h3>
                                <div>
                                    @if(b?.urls; as urls){
                                        @if(urls.facebook){
                                            <a mat-icon-button color="primary" [href]="urls.facebook" target="_blank"><mat-icon svgIcon="logo:facebook" paint="blue"></mat-icon></a>
                                        }
                                        @if(urls.instagram){
                                            <a mat-icon-button [href]="urls.instagram" target="_blank"><mat-icon svgIcon="logo:instagram" paint="blue"></mat-icon></a>
                                        }
                                        @if(urls.tiktok){
                                            <a mat-icon-button [href]="urls.tiktok" target="_blank"><mat-icon svgIcon="logo:tiktok" paint="blue"></mat-icon></a>
                                        }
                                        @if(urls.tripadvisor){
                                            <a mat-icon-button [href]="urls.tripadvisor" target="_blank"><mat-icon svgIcon="logo:tripadvisor" paint="blue"></mat-icon></a>
                                        }
                                        @if(urls.personal){
                                            <a mat-icon-button [href]="urls.personal" target="_blank" paint="blue"><mat-icon>link</mat-icon></a>
                                        }
                                    }
                                </div>
                            </div>
                            <p class="description font-light" [class.more]="showMore()">
                                {{b?.description}}
                            </p>
                            <span (click)="showMore.set(!showMore());" class="  interactive" paint="blue">{{showMore() ? 'Show less' : 'Read more'}}</span>
                            <br/>
                            <br/>
                            <mat-divider></mat-divider>
                            @if((b?.stores||[]).length){
                                <div class="outlets my-16">
                                    <h4 class="my-12 font-bold" paint="blue">
                                        Outlets
                                    </h4>
                                    <google-map mapId="brand-outlets" #map [zoom]="16" (mapInitialized)="centerMap()" [options]="{ fullscreenControl: true, mapTypeControl: false, clickableIcons: false }">
                                        @for (store of b?.stores; track store._id) {
                                            @let location = store.location;
                                            @let geo = { lat: location.geo.y, lng: location.geo.x };
                                            <div style="display: none;" class="cosmetic">
                                                <!-- !Definite items to be used by map -->
                                                <img class="brand-map-marker" #storeIcon [src]="(b?.logo_url | bucket) ?? 'old/cloudigo_loader.svg'" [fallback] alt="{{b?.name}} Location"/>
                                                <div #storeHeader>
                                                    <p class="m-0 font-bold">{{store.name}}</p>
                                                    <p class="m-0 font-light">{{[location.street,location.city,location.country] | join }}</p>
                                                </div>
                                                <div class="store-info-body" #storeContent>
                                                    <mat-divider></mat-divider>
                                                    <div class="mt-4 f-main-between f-cross-center">
                                                        <p class="m-0">Opening Hours</p>
                                                        @if(store.primary_phone){
                                                            @let phone = store.primary_cc + ' ' + store.primary_phone;
                                                            <a href="tel:{{phone}}" paint="blue">{{phone}}</a>
                                                        }
                                                    </div>
                                                    <ul style="padding-left: 10px; list-style: none;">
                                                        @for(timeslot of storeTimeslots()[store._id]; track timeslot[0]){
                                                            @let weekday = timeslot[0];
                                                            @let times = timeslot[1];
                                                            <li>
                                                                <span class="mr-8 store-timeslot">
                                                                    {{weekday}}
                                                                </span>
                                                                <span>{{times}}</span>
                                                            </li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                            <map-advanced-marker #storeMarker="mapAdvancedMarker" [position]="geo" [content]="storeIcon" [title]="store.name" (mapClick)="openInfo(storeInfo)"></map-advanced-marker>
                                            <map-info-window #storeInfo="mapInfoWindow" [position]="geo" [options]="{ pixelOffset: infoOffset, headerContent: storeHeader, content: storeContent }"></map-info-window>
                                        }
                                    </google-map>
                                    <!-- <div class="outlet-list">
                                        @for(outlet of b.stores; track outlet._id){
                                            @let loc = outlet.location;
                                            <div class="p-4 outlet f-main-between f-cross-center">
                                                <div class="outlet-info">
                                                    <p class="m-0">{{outlet.name}}</p>
                                                    <p class="m-0 font-light">{{[loc.street,loc.city,loc.country] | join}}</p>
                                                </div>
                                                <button mat-stroked-button>INFO</button>
                                            </div>
                                        }
                                    </div> -->
                                </div>
                            }
                            <mat-divider></mat-divider>
                            @if((b?.categories||[]).length){
                                <div class="categories my-16">
                                    <h4 class="my-12 font-bold" paint="blue">
                                        Categories
                                    </h4>
                                    <div class="category-list f-wrap cgap-4">
                                        @for(category of b?.categories; track category._id){
                                            <a mat-flat-button [routerLink]="['/search']" [queryParams]="{ s: category.name }">
                                                <mat-icon [svgIcon]="category.slug"></mat-icon>
                                                {{category.name}}
                                            </a>
                                        }
                                    </div>
                                </div>
                            }

                        </div>
                    }
                }
            </div>
        </mat-tab-nav-panel>
    </div>
</section>
